import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface TourState {
  activeTourId: string | null;
  stepIndex: number;
  /** Timestamp when "Resume" was requested; tour component uses it to re-show the tooltip */
  resumeRequestedAt: number;
}

interface TourActions {
  startTour: (tourId: string) => void;
  setStep: (index: number) => void;
  nextStep: () => void;
  prevStep: () => void;
  finishTour: () => void;
  skipTour: () => void;
  requestResume: () => void;
}

type TourStore = TourState & TourActions;

export const useTourStore = create<TourStore>()(
  persist(
    (set) => ({
      activeTourId: null,
      stepIndex: 0,
      resumeRequestedAt: 0,

      startTour: (tourId: string) =>
        set({ activeTourId: tourId, stepIndex: 0 }),

      setStep: (index: number) =>
        set((state) => (state.activeTourId ? { stepIndex: index } : state)),

      nextStep: () =>
        set((state) =>
          state.activeTourId ? { stepIndex: state.stepIndex + 1 } : state
        ),

      prevStep: () =>
        set((state) =>
          state.activeTourId && state.stepIndex > 0
            ? { stepIndex: state.stepIndex - 1 }
            : state
        ),

      finishTour: () => set({ activeTourId: null, stepIndex: 0 }),

      skipTour: () => set({ activeTourId: null, stepIndex: 0 }),

      requestResume: () => set({ resumeRequestedAt: Date.now() }),
    }),
    {
      name: 'tour-storage',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        activeTourId: state.activeTourId,
        stepIndex: state.stepIndex,
      }),
    }
  )
);
